import { hydraUiApi, useHydraUIAPIMutation, useQueryClient } from '@/services/api';
import { useAuth } from '@/services/auth';

export function useCopilotActions() {
  const queryClient = useQueryClient();
  const auth = useAuth();

  const deleteMutation = useHydraUIAPIMutation(
    (variables: { sessionId: number }) =>
      hydraUiApi.copilot.delete({
        params: { path: { account_id: String(auth.account.id), session_id: String(variables.sessionId) } },
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['getCopilotSessions'] });
      },
    },
  );

  const updateMutation = useHydraUIAPIMutation(
    (variables: { sessionId: number; name: string }) =>
      hydraUiApi.copilot.update({
        params: { path: { account_id: String(auth.account.id), session_id: String(variables.sessionId) } },
        body: { name: variables.name },
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['getCopilotSessions'] });
      },
    },
  );

  return {
    deleteSession: async (sessionId: number) => {
      await deleteMutation.mutateAsync({ sessionId });
    },
    renameSession: async (sessionId: number, name: string) => {
      await updateMutation.mutateAsync({ sessionId, name });
    },
  };
}
